import type { Store } from 'pinia';

export function syncStoreWithLocalStorage<T extends Store>(store: T) {
  const storeKey = `c4-collab-catman-${store.$id}Store`;
  const savedState = localStorage.getItem(storeKey);
  if (savedState) {
    store.$patch(JSON.parse(savedState) as typeof store.$state);
  }

  store.$subscribe((_mutation, state) => {
    localStorage.setItem(storeKey, JSON.stringify(state));
  });
}
